export const environment = {
    BASE_URL: 'serveturetest.com',
    WEB_URL: 'workn.serveturetest.com',
    DISPLAY_WEB_URL: '.serveturetest.com',
    PENTAHO_URL: 'http://pentahodev.serveturetest.com:8080',
};
